import React, { FC } from 'react';
import styled from '@emotion/styled';
import CheckIcon from '~Assets/icons/check.svg';

const Image = styled.div<{ icon: any }>`
  width: 16px;
  height: 16px;
  mask-image: url(${({ icon }) => icon});
  mask-size: contain;
  mask-repeat: no-repeat;
  user-select: none;
  -webkit-tap-highlight-color: transparent;
  background-color: var(--colorWhite);
`;

/** Use with useButton */
export const OptionButton = styled.div<{ selected: boolean; disabled?: boolean }>`
  opacity: ${({ disabled }) => (disabled ? 0.5 : 1)};
  display: flex;
  text-transform: none;
  font-weight: 400;
  justify-content: flex-start;
  align-items: center;
  gap: 16px;
  padding: 18px 16px;
  color: var(--colorWhite);
  transition: all 0.2s ease-out;
  background-color: ${({ selected }) =>
    selected ? 'var(--colorBlueGray1100)' : 'var(--colorBlueGray1200)'};
  &:active {
    background-color: var(--colorBlueGray1100);
  }
`;

const Circle = styled.div<{ active: boolean }>`
  display: flex;
  justify-content: center;
  align-items: center;
  background: ${({ active }) => (active ? 'var(--colorBlueGray800)' : 'var(--colorBlueGray1200)')};
  height: 24px;
  width: 24px;
  border-radius: 50%;
  border: ${(props) =>
    props.active ? '1px solid var(--colorBlueGray700)' : '1px solid var(--colorBlueGray1000)'};
`;

interface Props {
  active: boolean;
}

/** Radio options */
const RadioIcon: FC<Props> = ({ active }) => {
  return <Circle active={active}>{active && <Image icon={CheckIcon} />}</Circle>;
};

export default RadioIcon;
